import { InjectionToken } from '@angular/core';

export const SOFTLINE_MODULE_WWS_ABC_ANALYSIS = 'wws-abc-analysis';
export const SOFTLINE_PERMISSION_WWS_ABC_ANALYSIS = 'SOFTAPPS.WWS_ABC_ANALYSIS';

export interface WwsAbcAnalysisModuleConfig {
  /** Placeholder — replace with real module-level config flags. */
  enabled?: boolean;
}

export const DEFAULT_WWS_ABC_ANALYSIS_CONFIG: Required<WwsAbcAnalysisModuleConfig> = {
  enabled: true,
};

export const SOFTLINE_CONFIG_WWS_ABC_ANALYSIS =
  new InjectionToken<WwsAbcAnalysisModuleConfig>('SOFTLINE_CONFIG_WWS_ABC_ANALYSIS', {
    factory: () => DEFAULT_WWS_ABC_ANALYSIS_CONFIG,
  });
